import React from 'react'
import './styles.css'

export default function InfoItem({ text, image, icon }) {
  return (
    <div className="info-item">
      <div className="item-image">
        {icon ? (
          React.cloneElement(icon, {
            style: {
              ...icon.props.style,
              width: 60,
              height: 60,
            },
          })
        ) : (
          <img src={image} style={{ width: 50, height: 50 }} alt="info-item" />
        )}
      </div>
      <p
        style={{
          marginTop: 0,
          paddingTop: 0,
        }}
      >
        {text}
      </p>
    </div>
  )
}
